export default __webpack_public_path__ + "static/media/DemetrisPapademetriou-min.c62d663e.jpeg";